import { render, staticRenderFns } from "./digital-certificate.vue?vue&type=template&id=eebf5b16&scoped=true&"
import script from "./digital-certificate.vue?vue&type=script&lang=js&"
export * from "./digital-certificate.vue?vue&type=script&lang=js&"
import style0 from "./digital-certificate.vue?vue&type=style&index=0&id=eebf5b16&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eebf5b16",
  null
  
)

export default component.exports